import { ResultPage, ResultType } from "pages/success/ResultPage";
import { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useKeycloak } from "services/keycloak/hook";
import { AccountLayout } from "components/store-layout/AccountLayout";

export function StudioLogin() {
  const keycloak = useKeycloak();
  const intl = useIntl();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const tokens = {
    accessToken: keycloak.token,
    refreshToken: keycloak.refreshToken,
  };

  const query = {
    request: JSON.stringify(tokens),

    onSuccess: function (result: string) {
      console.log(result);

      setLoading(false);
      setError(false);
    },
    onFailure: function (error_code: number, error_message: string) {
      console.log("Error: (" + error_code + ") " + error_message);

      setLoading(false);
      setError(true);
    }
  };

  useMemo(() => {
    //@ts-ignore
    window.cefQueryJmixStore?.(query);
  }, []);

  if (error) {
    return (
      <AccountLayout>
        <ResultPage
          type={ResultType.ERROR}
          title={intl.formatMessage({ id: "jmix-account.studio-login.error" })}
        />
      </AccountLayout>
    );
  }

  return (
    <AccountLayout>
      <ResultPage
        loading={loading}
        type={ResultType.SUCCESS}
        title={intl.formatMessage({ id: "jmix-account.studio-login.success" })}
      />
    </AccountLayout>
  );
}
